<template>
    <div class="widget-container">
        <div class="display-content">
            <!-- Widget Demandes d'Intervention -->
            <InterventionRequest
                v-if="visible"
                :key="requestIntervention"
                :equipementDemandeInterventionData="demandesData"
                :equipementDemandeInterventionDataLoading="isDemandesInterventionStatsLoading"
                :isBim="true"
                :title="$t('equipement.dashboard.interventionRequest')"
                class="ombre"
            />

            <!-- Widget Interventions Non-Préventives -->
            <PreventiveOut
                v-if="visible"
                :equipementInterventionNonPreventiveData="nonPreventiveData"
                :equipementInterventionNonPreventiveLoading="isNonPreventiveStatsLoading"
                :isBim="true"
                :title="$t('equipement.dashboard.travaux')"
                class="ombre"
            />
            <!-- Widget Devis -->
            <Estimate
                v-if="visible"
                :equipementDevisData="devisData"
                :equipementDevisLoading="isDevisStatsLoading"
                :isBim="true"
                :title="$t('equipement.dashboard.devis')"
                class="ombre"
            />

            <!-- Widget Interventions Préventives -->
            <Preventive
                v-if="visible"
                :key="preventiveKey"
                :equipementInterventionNonPreventiveDataChart="preventiveDataChart"
                :equipementInterventionNonPreventiveDataCircle="preventiveDataCircle"
                :equipementInterventionNonPreventiveLoading="
                    isPreventiveStatsCircleLoading || isPreventiveStatsChartLoading
                "
                :isBim="true"
                :title="$t('equipement.dashboard.preventif')"
                class="ombre"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { EquipementAction } from '@/modules/Equipements/store/actions-types';
import InterventionRequest from '@/modules/Home/components/InterventionRequest.vue';
import Estimate from '@/modules/Home/components/Estimate.vue';
import Preventive from '@/modules/Home/components/Preventive.vue';
import PreventiveOut from '@/modules/Home/components/PreventiveOut.vue';

export default defineComponent({
    name: 'DashboardTab',
    components: {
        PreventiveOut,
        Preventive,
        Estimate,
        InterventionRequest,
    },
    props: {
        phaseId: {
            type: Number,
            required: true,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            preventiveKey: 0,
            requestIntervention: 0,
        };
    },
    watch: {
        visible(newVal: boolean) {
            if (newVal) {
                this.preventiveKey++;
                this.requestIntervention++;
            }
        },
    },
    computed: {
        nonPreventiveData() {
            return this.$store.getters['equipementState/getNonPreventiveStats'];
        },
        preventiveDataCircle() {
            return this.$store.getters['equipementState/getPreventiveStatsCircle'];
        },
        preventiveDataChart() {
            return this.$store.getters['equipementState/getPreventiveStatsChart'];
        },
        devisData() {
            return this.$store.getters['equipementState/getDevisStats'];
        },
        demandesData() {
            return this.$store.getters['equipementState/getDemandesInterventionStats'];
        },
        isLoading() {
            return this.$store.getters['equipementState/isLoading'];
        },
        isNonPreventiveStatsLoading() {
            return this.$store.getters['equipementState/isNonPreventiveStatsLoading'];
        },
        isPreventiveStatsCircleLoading() {
            return this.$store.getters['equipementState/isPreventiveStatsCircleLoading'];
        },
        isPreventiveStatsChartLoading() {
            return this.$store.getters['equipementState/isPreventiveStatsChartLoading'];
        },
        isDevisStatsLoading() {
            return this.$store.getters['equipementState/isDevisStatsLoading'];
        },
        isDemandesInterventionStatsLoading() {
            return this.$store.getters['equipementState/isDemandesInterventionStatsLoading'];
        },
    },
    mounted() {
        this.getStatistiques();
    },
    methods: {
        getStatistiques() {
            this.$store.dispatch(`equipementState/${EquipementAction.GET_DEVIS_STATS}`, this.phaseId);
            this.$store.dispatch(`equipementState/${EquipementAction.GET_DEMANDES_INTERVENTION_STATS}`, this.phaseId);
            this.$store.dispatch(`equipementState/${EquipementAction.GET_NON_PREVENTIVE_STATS}`, this.phaseId);
            this.$store.dispatch(`equipementState/${EquipementAction.GET_PREVENTIVE_STATS_CIRCLE}`, this.phaseId);
            this.$store.dispatch(`equipementState/${EquipementAction.GET_PREVENTIVE_STATS_CHART}`, this.phaseId);
        },
    },
});
</script>

<style scoped>
.ombre {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.display-content {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    height: 71.5vh;
}
@media screen and (min-width: 980px) {
    .widget-container {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
    }
}
@media screen and (max-height: 800px) {
    .widget-container {
    }
}
@media (max-width: 1000px) {
    .widget-container {
        margin-right: auto;
        margin-left: auto;
    }
}
@media (min-width: 980px) and (max-width: 1005px) {
    .widget-container {
        flex-flow: column wrap;
    }
}
</style>
